import React from "react";
import { OktaAuth } from "@okta/okta-auth-js";
import { useConfig } from "./configContext/ConfigContext.component";
import OktaAuthLayer from "./OktaAuthLayer.component";

let oktaLocal: OktaAuth | undefined = undefined;

const OktaAuthLayerFromConfig: React.FC = ({ children }) => {
  const config = useConfig();
  if (config) {
    if (!oktaLocal) {
      oktaLocal = new OktaAuth(config.okta);
    }
  }

  if (oktaLocal) {
    return <OktaAuthLayer okta={oktaLocal}>{children}</OktaAuthLayer>;
  } else {
    return <></>;
  }
};

export default OktaAuthLayerFromConfig;
